import React from "react";


export default function BranchMap({ mapImage }) {
  return (
    <div className="container my-5">
        <h2 className="text-left mb-4 section-heading">
        Our Branches
      </h2>
    <div style={styles.mapContainer}>
      <img src={mapImage} alt="World Map" style={styles.mapImage} />
    </div>
    </div>
  );
}

const styles = {
  mapContainer: {
    position: "relative",
    width: "100%",
    maxWidth: "800px",
    margin: "0 auto",
  },
  mapImage: {
    width: "100%",
    display: "block",
  },
  marker: {
    position: "absolute",
    width: "20px",
    height: "20px",
    backgroundColor: "red",
    borderRadius: "50%",
    transform: "translate(-50%, -50%)",
    cursor: "pointer",
    border: "2px solid white",
  },
};
